import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { SidebarProvider, useSidebar } from './SidebarContext';

function Backdrop() {
  const { open, close } = useSidebar();
  if (!open) return null;
  return <div className="sidebar-backdrop" onClick={close}></div>;
}

export default function Layout() {
  return (
    <SidebarProvider>
      <div className="app-layout">
        <Sidebar />
        <Backdrop />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </SidebarProvider>
  );
}
